import React, { useState } from 'react';
import { Button, Form, FormGroup, Modal, Row } from 'react-bootstrap';
import { loadProductAccessories } from '../../store/api/GetAllProduct';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faList, faTimes } from '@fortawesome/free-solid-svg-icons';
import BihamtaTable from '../../../Components/BihamtaTable';
const ModalSelectProductAccessory = (props) => {
    const { popData, setPopData } = props;
    const [dataList, setDataList] = useState([]);

    const search = () => {
        let itemDesc = document.getElementsByName("ItemDescForSeach")[0].value;
        let data = {};
        data.ProductID = popData.productID;
        data.ProductTypeID = popData.productType
        data.AccessoryName = itemDesc;
        setDataList("PENDING");
        loadProductAccessories(data, setDataList);
    }
    function select(item) {
        if (typeof popData.setData === "function") {
            const { e, target, ...selected } = item;
            popData.setData(selected);
        }
        close();
    }
    function close() {
        setPopData({
            show: false
        })
    }

    const tableCols = [
        { colTitle: "ردیف", colName: "RowNumber", showInMobile: true },
        { colTitle: "نام لوازم", colName: "AccessoryName", showInMobile: true }
    ]
    return (
        <Modal show={popData.show} style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header className='headerStyle'>
                <span>
                    <FontAwesomeIcon icon={faList} size='lg' />&nbsp;
                    لوازم همراه
                </span>
                <FontAwesomeIcon icon={faTimes} onClick={close} size='lg' />
            </Modal.Header>
            <Modal.Body className='bodyStyle'>
                <Row>
                    <FormGroup>
                        <Form.Control name="ItemDescForSeach" placeholder="نام" />
                    </FormGroup>
                </Row>
                <Button className="w-100 mt-2" onClick={search}>جستجو</Button>
                <BihamtaTable columns={tableCols} dataList={dataList} rowClick={select} maxHeight={500} />
            </Modal.Body>
        </Modal>
    )
}
export default ModalSelectProductAccessory;